<template lang="pug">
   modal.alert(:options="dopts",@confirm="$emit('confirm')",@close="$emit('close')")
      svg.alert__icon(height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg")
         path(d="M2 42h44L24 4 2 42zm24-6h-4v-4h4v4zm0-8h-4v-8h4v8z")

      p.alert__message(v-text="message")

</template>

<script>
   import Modal from '../../components/common/dialog/dialog.vue';
   import store from '../../store';

   export default {
      name: 'Confirmer',
      store,
      components: { Modal },
      data() {
         return {
            dopts: { showHeader : false, closeOnBackdrop: false, showCancel: false },
            message: ''
         };
      },
      mounted() {
         this.message = this.$options.message;
      }
   };
</script>

<style>
   .alert .modal__container {
      width: 18rem;
   }

   .alert__icon {
      fill: #fda961;
      margin: 0 auto;
      width: 6rem;
      height: 6rem;
      display: block;
   }

   .alert__message {
      font-size: .75rem;
      line-height: 1.5;
   }
</style>
